import { Component, Input } from '@angular/core';
import { ChatMessage } from '../models/chat-message.model';

@Component({
  selector: 'lib-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.scss'],
  standalone: false
})
export class ChatMessageComponent {
  @Input() message!: ChatMessage;
}
